import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
const sourceSuggestionShownEvent = EVENT_PAYLOAD;
const sourceSuggestionClickedEvent = EVENT_PAYLOAD;
export function useAskSourceSuggestionAnalytics(query) {
    const { track } = useInstrumentation();
    const onSuggestionShown = useCallback(({ source, connected }) => {
        track(sourceSuggestionShownEvent({
            name: 'source suggestion shown',
            data: { query, source, connected },
        }));
    }, [query, track]);
    const onSuggestionClick = useCallback(({ source, connected }) => {
        track(sourceSuggestionClickedEvent({
            name: 'source suggestion clicked',
            data: { query, source, connected },
        }));
    }, [query, track]);
    return useMemo(() => ({ onSuggestionShown, onSuggestionClick }), [onSuggestionClick, onSuggestionShown]);
}
//# sourceMappingURL=useAskSourceSuggestionAnalytics.js.map